'use client';
import { useState } from 'react';
import { createRoot } from 'react-dom/client';

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';

import { Button } from './ui/button';

const ALERT_DIALOG_VIEWPORT_ID = 'alert-dialog-viewport';

type AlertDialogProps = {
  title: string;
  message?: string;
  el?: React.ReactNode;
  onClose?: () => void;
};

export function alertWithDialog({ onClose, ...props }: AlertDialogProps) {
  const viewport = document.getElementById(ALERT_DIALOG_VIEWPORT_ID);

  if (!viewport) {
    throw new Error('alert dialog viewport not found');
  } else {
    return new Promise<void>((resolve) => {
      const root = createRoot(viewport);

      root.render(
        <AlertDialog
          {...props}
          onClose={() => {
            onClose?.();

            root.unmount();

            resolve();
          }}
        />
      );
    });
  }
}

function AlertDialog({ el, title, message, onClose }: AlertDialogProps) {
  const [open, setOpen] = useState(true);
  function close() {
    setOpen(false);
    onClose?.();
  }

  return (
    <Dialog onOpenChange={(open) => !open && close()} open={open}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{message || null}</DialogDescription>
          <div>{el || null}</div>
          <div className='flex flex-row-reverse gap-4 pt-4'>
            <Button onClick={close}>Ok</Button>
          </div>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}

export function AlertDialogViewport() {
  return <div id={ALERT_DIALOG_VIEWPORT_ID} />;
}
